<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- Card Encabezado -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between">
        <div class="row items-center">
          <q-icon name="menu_book" size="md" class="q-mr-sm" />
          <div>
            <div class="text-h6 text-weight-bold">DOCUMENTACIÓN DE API SUNAT / DNI / TIPO DE CAMBIO</div>
            <div class="text-caption text-blue-2">Guía de integración y ejemplos de consumo HTTP</div>
          </div>
        </div>
        <q-btn flat color="white" icon="arrow_back" label="Volver a Inicio" to="/" />
      </div>
    </q-card>

    <div class="row q-col-gutter-md">
      <!-- RUC -->
      <div class="col-12 col-md-6">
        <q-card class="shadow-2 rounded-borders fit">
          <q-card-section class="bg-blue-1">
            <div class="text-subtitle1 text-weight-bold text-primary row items-center">
              <q-badge color="primary" class="q-mr-sm">GET</q-badge>
              https://aveoperu.com/api/ruc/{numero}
            </div>
          </q-card-section>
          <q-card-section>
            <q-input
              v-model="textAreaValue"
              type="textarea"
              outlined
              readonly
              rows="8"
              label="Ejemplo de Consumo (POSTMAN / cURL)"
            />
          </q-card-section>
          <q-card-actions align="right" class="q-pa-md">
            <q-btn color="primary" icon="content_copy" label="Copiar Código" unelevated @click="copyRuc" />
          </q-card-actions>
        </q-card>
      </div>

      <!-- DNI -->
      <div class="col-12 col-md-6">
        <q-card class="shadow-2 rounded-borders fit">
          <q-card-section class="bg-blue-1">
            <div class="text-subtitle1 text-weight-bold text-primary row items-center">
              <q-badge color="primary" class="q-mr-sm">GET</q-badge>
              https://aveoperu.com/api/dni/{numero}
            </div>
          </q-card-section>
          <q-card-section>
            <q-input
              v-model="textAreadni"
              type="textarea"
              outlined
              readonly
              rows="8"
              label="Ejemplo de Consumo (POSTMAN / cURL)"
            />
          </q-card-section>
          <q-card-actions align="right" class="q-pa-md">
            <q-btn color="primary" icon="content_copy" label="Copiar Código" unelevated @click="copyDni" />
          </q-card-actions>
        </q-card>
      </div>

      <!-- Fecha -->
      <div class="col-12 col-md-6">
        <q-card class="shadow-2 rounded-borders fit">
          <q-card-section class="bg-blue-1">
            <div class="text-subtitle1 text-weight-bold text-primary row items-center">
              <q-badge color="primary" class="q-mr-sm">GET</q-badge>
              https://aveoperu.com/api/fecha/{yyyy-mm-dd}
            </div>
          </q-card-section>
          <q-card-section>
            <q-input
              v-model="textAreafecha"
              type="textarea"
              outlined
              readonly
              rows="8"
              label="Ejemplo de Consumo (POSTMAN / cURL)"
            />
          </q-card-section>
          <q-card-actions align="right" class="q-pa-md">
            <q-btn color="primary" icon="content_copy" label="Copiar Código" unelevated @click="copyFecha" />
          </q-card-actions>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: "DocumentacionPage",
  data() {
    return {
      textAreaValue: `curl --location --request GET 'https://aveoperu.com/api/ruc/20600000000' \\
--header 'Authorization: Bearer YOUR_TOKEN'`,
      textAreadni: `curl --location --request GET 'https://aveoperu.com/api/dni/00000000' \\
--header 'Authorization: Bearer YOUR_TOKEN'`,
      textAreafecha: `curl --location --request GET 'https://aveoperu.com/api/fecha/2026-08-01' \\
--header 'Authorization: Bearer YOUR_TOKEN'`,
    };
  },
  methods: {
    copyRuc() {
      navigator.clipboard.writeText(this.textAreaValue);
      this.notificar("Copiado al portapapeles", "positive");
    },
    copyDni() {
      navigator.clipboard.writeText(this.textAreadni);
      this.notificar("Copiado al portapapeles", "positive");
    },
    copyFecha() {
      navigator.clipboard.writeText(this.textAreafecha);
      this.notificar("Copiado al portapapeles", "positive");
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 2000
        });
      } else {
        alert(msg);
      }
    }
  }
};
</script>
